export enum DATA_FIELD_ROLE {
    SHIPPING_ADDRESS_FIRST_NAME = 'ShippingAddress::firstName',
    SHIPPING_ADDRESS_LAST_NAME = 'ShippingAddress::lastName',
    SHIPPING_ADDRESS_COMPANY_NAME = 'ShippingAddress::companyName',
    SHIPPING_ADDRESS_ADDRESS_LINE_1 = 'ShippingAddress::addressLine1',
    SHIPPING_ADDRESS_ADDRESS_LINE_2 = 'ShippingAddress::addressLine2',
    SHIPPING_ADDRESS_CITY_NAME = 'ShippingAddress::cityName',
    SHIPPING_ADDRESS_CITY_POSTAL_CODE = 'ShippingAddress::cityPostalCode',
    SHIPPING_ADDRESS_STATE = 'ShippingAddress::state',
    SHIPPING_ADDRESS_COUNTRY = 'ShippingAddress::country',
    SHIPPING_ADDRESS_PARCEL_NAME = 'InPostPaczkomatShippingMethod::shipXPointName',
    CONTACT_DATA_FIRST_NAME = 'ContactPersonData::firstName',
    CONTACT_DATA_LAST_NAME = 'ContactPersonData::lastName',
    CONTACT_DATA_EMAIL = 'ContactPersonData::mail',
    CONTACT_DATA_PHONE = 'ContactPersonData::phone',
    PAYMENT_METHOD_RETURN_URL = 'PayPalPayMethod::returnURL',
    PAYMENT_METHOD_CANCEL_URL = 'PayPalPayMethod::cancelURL',
    PAYMENT_METHOD_CONTINUE_URL = 'PayUMethod::continueURL',
}
